import {A11Y_FOCUS_VISIBLE} from '@amblique/king-living/app/theme/foundations/a11y-focus-visible';

/** Add to cart confirmation page — hero + upsell grid. */
const AddToCartUpsell = {
  parts: [
    'root',
    'heroSection',
    'heroInner',
    'heroMainColumn',
    'heroHeading',
    'heroMainContent',
    'heroThumbnailWrapper',
    'heroThumbnailImage',
    'heroProductTextColumn',
    'heroProductName',
    'heroProductDescription',
    'heroActionsColumn',
    'heroActions',
    'heroCtaButton',
    'recommenderSection',
    'recommenderInner',
    'recommenderHeading',
    'upsellGrid'
  ],
  baseStyle: {
    root: {
      width: '100%',
      minHeight: '100vh',
    },
    heroSection: {
      width: '100vw',
      marginLeft: 'calc(-50vw + 50%)',
      marginRight: 'calc(-50vw + 50%)',
      background: 'var(--Primary-Pale-Linen, #F7F5F0)',
    },
    heroInner: {
      maxWidth: 'container.xxl',
      marginX: 'auto',
      paddingX: {base: 5, lg: 20},
      paddingY: {base: 12, lg: 16},
      display: 'flex',
      flexDirection: {base: 'column', lg: 'row'},
      alignItems: {base: 'stretch', lg: 'flex-start'},
      gap: {base: 6, lg: '6.5rem'},
    },
    heroMainColumn: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      minWidth: 0,
    },
    heroHeading: {
      color: 'brandColors.greyscale',
      fontFamily: 'heading',
      fontSize: {base: 'xl', lg: '2rem'},
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: {base: 'normal', lg: 'headingTight'},
      lineHeight: {base: 1.5, lg: 1.4},
      margin: 0,
    },
    heroMainContent: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: {base: 4, lg: 6},
      width: '100%',
    },
    heroProductTextColumn: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: '6px',
      justifyContent: 'center',
      minWidth: 0,
      py: 2,
    },
    heroThumbnailWrapper: {
      alignSelf: 'flex-start',
      bg: 'background.secondary',
      flexShrink: 0,
      height: {base: 18, lg: 30},
      overflow: 'hidden',
      width: {base: 18, lg: 30},
    },
    heroThumbnailImage: {
      height: '100%',
      objectFit: 'contain',
      width: '100%',
    },
    heroProductName: {
      color: 'grayAlpha.90',
      fontFamily: 'body',
      fontSize: 'md',
      fontStyle: 'normal',
      fontVariantNumeric: 'lining-nums proportional-nums',
      fontWeight: {base: 500, lg: 600},
      lineHeight: 1.4,
    },
    heroProductDescription: {
      color: 'grayAlpha.70',
      fontFamily: 'body',
      fontSize: {base: '0.8125rem', lg: 'xs'},
      fontWeight: 400,
      lineHeight: 1.2,
    },
    heroActionsColumn: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      gap: 4,
      minW: {lg: '285px'},
      width: {base: '100%', lg: 'auto'},
    },
    heroActions: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      width: '100%',
      sx: {
        '& .add-to-cart-upsell__cta:focus-visible, & .add-to-cart-upsell__cta[data-focus-visible], & .add-to-cart-upsell__cta[data-focus-visible-added], & .add-to-cart-upsell__cta.focus-visible':
          A11Y_FOCUS_VISIBLE._focusVisible,
      },
    },
    /** Go to checkout / Continue shopping — label 14px on all breakpoints (page-only). */
    heroCtaButton: {
      fontSize: '14px',
      fontWeight: 600,
      minH: '54px',
    },
    recommenderSection: {
      bg: 'whiteAlpha.700',
      marginLeft: 'calc(-50vw + 50%)',
      marginRight: 'calc(-50vw + 50%)',
      overflow: 'hidden',
      width: '100vw',
    },
    recommenderInner: {
      boxSizing: 'border-box',
      marginX: 'auto',
      maxWidth: 'container.xxl',
      paddingBottom: {base: 20, lg: 30},
      paddingTop: {base: 12, lg: 20},
      paddingX: {base: '4px', lg: 20},
      width: '100%',
    },
    recommenderHeading: {
      color: 'brandColors.greyscale',
      fontFamily: 'heading',
      fontSize: {base: '2rem', lg: '2.5rem'},
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: {base: '-0.01em', lg: '-0.01em'},
      lineHeight: 1.2,
      marginBottom: {base: 12, lg: 12},
      paddingX: {base: '16px', lg: 'unset'},
    },
    upsellGrid: {
      columnGap: {base: 1, lg: 1},
      rowGap: {base: 6, lg: 10},
      width: '100%',
    },
  },
};

export default AddToCartUpsell;
